export default (name, bgColor = '#222', color = '#bada55') => console.log(`%c [COMPONENT] --${name}-- was loaded `, `background: ${bgColor}; color: ${color}`);

